import { useState } from "react";
import { ReactComponent as ConfigIcon } from "assets/config-icon.svg";
import { PopupTemplate } from "templates/PopupTemplate";
import * as S from "./styles";

type ChangeMarkerColorProps = {
  getColor: (color: string) => void;
};

export default function ChangeMarkerColor({
  getColor,
}: ChangeMarkerColorProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [color, setColor] = useState("black");

  function handleOnClick() {
    setIsModalOpen(!isModalOpen);
  }

  return (
    <S.Container>
      <button>
        <ConfigIcon onClick={handleOnClick} />
      </button>

      {isModalOpen && (
        <S.Popup>
          <PopupTemplate
            title="Configurações"
            onPopupClose={handleOnClick}
            subtitle="Selecione a cor do ícone"
          >
            <S.ColorsContainer>
              <S.ColorInput
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setColor(event.target.value);
                  getColor(color);
                }}
                value={color}
                type="color"
              />
            </S.ColorsContainer>
          </PopupTemplate>
        </S.Popup>
      )}
    </S.Container>
  );
}
